import { render } from "./MarketingIcon.vue?vue&type=template&id=36b8a2b4"
import script from "./MarketingIcon.vue?vue&type=script&lang=js"
export * from "./MarketingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__